import { render } from "./WalineComment.vue?vue&type=template&id=3442766e&scoped=true"
import script from "./WalineComment.vue?vue&type=script&lang=js"
export * from "./WalineComment.vue?vue&type=script&lang=js"

import "./WalineComment.vue?vue&type=style&index=0&id=3442766e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3442766e"]])

export default __exports__